import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from 'redux/slices/dataSlice';
import {
  filterByLastNameSelector,
  filterByNameSelector,
  filterByDocumentSelector,
  filterByBatchSelector
} from 'redux/selectors';


function SearchField() {
  const dispatch = useDispatch();
  const filterByName = useSelector(filterByNameSelector) || '';
  const filterByLastName = useSelector(filterByLastNameSelector) || '';
  const filterByDocument = useSelector(filterByDocumentSelector) || '';
  const filterByBatch = useSelector(filterByBatchSelector) || '';
  // const [search, setSearch] = useState('');

  const handleSearchChange = (e) => {
    const searchInput = e.target.value;
    dispatch(setFilters({ [e.target.id]: searchInput }));
  };

  return (
    <Grid spacing={2}>
      <TextField
        variant="outlined"
        placeholder="Buscar por nombre"
        size="small"
        margin="dense"
        shrink="false"
        value={filterByName}
        id='filterByName'
        onChange={handleSearchChange}
      />
      <TextField
        variant="outlined"
        placeholder="Buscar por apellido"
        size="small"
        margin="dense"
        shrink="false"
        value={filterByLastName}
        id='filterByLastName'
        onChange={handleSearchChange}
      />
      <TextField
        variant="outlined"
        placeholder="Buscar por CUIL"
        size="small"
        margin="dense"
        shrink="false"
        value={filterByDocument}
        id='filterByDocument'
        onChange={handleSearchChange}
      />
      <TextField
        variant="outlined"
        placeholder="Buscar por Nro Lote"
        size="small"
        margin="dense"
        shrink="false"
        value={filterByBatch}
        id='filterByBatch'
        onChange={handleSearchChange}
      />
    </Grid>
  );
}

export default SearchField;
